angular.module("UI8.components").component("hireDirectory", {
  template: `<div class="hired">
      <div class="container">
        <div class="hired__head">
          <h1 class="hired__title">Hire a designer</h1>
          <p class="hired__subtitle">Work with designers from the UI8 community. Browse their work, then send a brief.</p>
        </div>

        <div class="tagrow" ng-if="$ctrl.tags.length">
          <button class="tagrow__chip" ng-class="{active: !$ctrl.tag}" ng-click="$ctrl.filter(null)">All</button>
          <button class="tagrow__chip" ng-repeat="t in $ctrl.tags track by t" ng-class="{active: $ctrl.tag === t}" ng-click="$ctrl.filter(t)">{{ t }}</button>
        </div>

        <div class="hired__grid" ng-if="$ctrl.designers.length">
          <a class="hired__card" ng-repeat="d in $ctrl.designers track by d._id" ng-href="/users/{{ d.slug }}">
            <div class="hired__person">
              <div class="hired__avatar">
                <img ng-if="d.avatar_url" ng-src="{{ d.avatar_url }}" alt="{{ d.name }}">
                <div class="hired__initial" ng-if="!d.avatar_url">{{ d.name.charAt(0) }}</div>
              </div>
              <div class="hired__id">
                <div class="hired__name">
                  {{ d.name }}
                  <span class="hchip hchip--founding" ng-if="d.badge === 'founding'">Founding Member</span>
                  <span class="hchip" ng-if="d.badge === 'verified'">Verified</span>
                </div>
                <div class="hired__location" ng-if="d.location">{{ d.location }}</div>
              </div>
            </div>
            <div class="hired__shots" ng-if="d.shots.length">
              <div class="hired__shot" ng-repeat="s in d.shots track by s._id" ng-style="{'background-color': $ctrl.shotColor(s)}">
                <img ng-src="{{ $ctrl.shotImage(s) }}" loading="lazy" alt="{{ s.title }}">
              </div>
            </div>
            <div class="hired__go">View profile</div>
          </a>
        </div>

        <div class="hired__empty" ng-if="!$ctrl.designers.length && !$ctrl.loading">
          <p>No designers found{{ $ctrl.tag ? " for that specialty" : "" }}.</p>
        </div>
        <div class="loader" ng-if="$ctrl.loading"></div>
      </div>
    </div>`,

  controller: function (HireService, $scope) {
    var ctrl = this;
    var S3_IMAGE_SERVER = "https://images.ui8.net";

    ctrl.designers = [];
    ctrl.tags = [];
    ctrl.tag = null;
    ctrl.loading = true;

    function load() {
      ctrl.loading = true;
      HireService.directory(ctrl.tag).then(function (res) {
        ctrl.loading = false;
        ctrl.designers = (res && res.designers) || [];
        if (res && res.tags && !ctrl.tags.length) ctrl.tags = res.tags;
        $scope.$applyAsync();
      });
    }

    ctrl.$onInit = load;

    ctrl.filter = function (tag) {
      ctrl.tag = tag;
      load();
    };

    // Same rendition convention as shot-card.js
    ctrl.shotImage = function (shot) {
      var image = (shot.images && shot.images[0]) || {};
      if (image.resized) {
        return (
          S3_IMAGE_SERVER +
          "/shot/" +
          shot._id +
          "/" +
          image._id +
          "_card_" +
          image.version +
          ".webp"
        );
      }
      return image.url;
    };

    ctrl.shotColor = function (shot) {
      var image = (shot.images && shot.images[0]) || {};
      return image.color || "";
    };
  },
});
